import api from './api'

export const labStepService = {
  // Get all steps for a lab
  getSteps: async (labId) => {
    const response = await api.get(`/labs/${labId}/steps`)
    return response.data
  },

  // Toggle step completion
  toggleStep: async (labId, stepId) => {
    const response = await api.post(`/labs/${labId}/steps/${stepId}/toggle`)
    return response.data
  },

  // Get user's step progress
  getProgress: async (labId) => {
    const response = await api.get(`/labs/${labId}/steps/progress`)
    return response.data
  },
}
